import { combineReducers } from 'redux'
import { actives } from 'reduxes/slices/actives/reducers'
import { api } from 'reduxes/slices/api/reducers'
import { current } from 'reduxes/slices/current/reducers'
import { invalidSubStore as invalid } from 'reduxes/slices/invalid/reducers'
import { paging } from 'reduxes/slices/paging/reducers'
import { related } from 'reduxes/slices/related/reducers'
import { selected } from 'reduxes/slices/selected/reducers'
import { replyTimelineId } from 'reduxes/slices/timelines/reducers'

import { apiErrors } from '../../slices/api_errors/reducers'
import { appState } from '../../slices/app_state/reducers'
import { errors } from '../../slices/errors/reducers'

const adminReducer = combineReducers({
  api,
  current,
  invalid,
  actives,
  paging,
  related,
  replyTimelineId,
  selected,
  appState,
  apiErrors,
  errors,
})

// No longer used. Can be used to update across multiple reducer slices. See git history for an example.
const rootReducer = (state, action) => {
  return adminReducer(state, action)
}

export default rootReducer
